import React from "react";
import paths from "@icarius-router/paths";
import CommonPage from "@icarius-common/commonPage";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import useMyApprovedConsents from "./useMyApprovedConsents";
import ConsentDialog from "@icarius-common/consentDialog";
import { getLocalizedString } from "@icarius-localization/strings";

const MyApprovedConsents = () => {

  const {
    isLoading,
    data,
    dialogIsOpen,
    consentSelected,
    handleOpenDialog,
    handleCloseDialog,
    handlePreview,
  } = useMyApprovedConsents();

  const previewButton = (gridRef) => (
    <CustomIconButton
      title={getLocalizedString("previewTemplate")}
      onClick={() => handlePreview(gridRef)}
      type={"preview"}
    />
  )

  return (
    <CommonPage
      isLoading={isLoading}
      title={getLocalizedString("myApprovedConsents")}
      gridTitle={getLocalizedString("myApprovedConsents")}
      columnDefPage={paths.myApprovedConsents}
      rowData={data}
      handleRowClick={handleOpenDialog}
      menuItems={[previewButton]}
      hasExpand
      hasHelp
      hasSelectAll
    >
      {
        dialogIsOpen &&
        <ConsentDialog
          open={dialogIsOpen}
          data={consentSelected}
          handleClose={handleCloseDialog}
          readOnly
        />
      }
    </CommonPage>
  )
}

export default MyApprovedConsents;